module.exports = __webpack_public_path__ + "static/media/date_arrow.f899d58e.svg";